import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UnsavedChangesService } from '@app/shared/services/unsaved-changes-service';

@Component({
  selector: 'portal-unsaved-changes-bar',
  templateUrl: './unsaved-changes-bar.component.html',
  standalone: false,
})
export class UnsavedChangesBarComponent implements OnChanges, OnDestroy, OnInit {
  @Input()
  public dirty: boolean = false;

  @Input()
  public invalid: boolean = false;

  @Input()
  public saveButton?: string;

  @Input()
  public state: boolean;

  @Output()
  public onReset: EventEmitter<void> = new EventEmitter();

  @Output()
  public onSave: EventEmitter<void> = new EventEmitter();

  constructor(private unsavedChangesService: UnsavedChangesService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('dirty' in changes) {
      if (changes['dirty'].currentValue === true) {
        this.unsavedChangesService.askForConfirmation();
      } else {
        this.unsavedChangesService.reset();
      }
    }
  }

  ngOnDestroy() {}

  ngOnInit() {}

  reset() {
    this.onReset.emit();

    this.unsavedChangesService.reset();
  }

  save() {
    this.onSave.emit();
  }
}
